import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  CREATE_USER_DEPOSIT_ADDRESS,
  CREATE_USER_DEPOSIT_RECOED,
  CREATE_USER_DEPOSIT_RECOED_LIST,
} from "@/config";
import { Trans } from "react-i18next";
import PostRequest from "@/components/PostRequest";
import { useAuthContext } from "@/auth/useAuthContext";

export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  const user_deposit_record = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "record": {
        "userId": "test01",
        "recordId": "20240327101257124644294408536064",
        'coinId': 1340,
        "chain": "CELO",
        "contract": "42220",
        "coinSymbol": "CELO",
        "txId": "0x1d53f75cc9024af4b8015e490691ccf04169551da23eaa45b93ec0b1b0a8a0cd",
        "coinUSDPrice": "1.3346",
        'fromAddress': "0x057bf001fce6394129142e3b39ae1b2ee4743011",
        "toAddress": "0x76d9b46857a564477bde23ea71f487a411827b40",
        'toMemo': "",
        'amount': "0.11",
        "serviceFee": "0.000033",
        'status': "Success",
        'arrivedAt': 1711534377,
      },
    },
  }`,
    go: {
      http_ex_code: `package main
  
  import (
  "bytes"
  "crypto/hmac"
  "crypto/sha256"
  "encoding/hex"
  "fmt"
  "io"
  "net/http"
  "time"
  )
  
  func main() {
  
  appId := "*** your appId ***"
  appSecret := "*** your appSecret ***"
  
  // With request params
  path := "${check ? CREATE_USER_DEPOSIT_RECOED : "***"}"
  args := []byte(${`{
      "recordId": "20240227084448114112864297488384"
  }`})
  
  //sign
  timestamp := time.Now().Unix()
  
  signText := fmt.Sprintf("%s%d", appId, timestamp)
  if len(args) != 0 {
    signText = fmt.Sprintf("%s%s", signText, args)
  }
  
  h := hmac.New(sha256.New, []byte(appSecret))
  h.Write([]byte(signText))
  sign := hex.EncodeToString(h.Sum(nil)[:])
  
  fmt.Printf("Sign: %s", sign)
  
  // Making API call
  client := http.Client{}
  request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
  request.Header.Set("Appid", appId)
  request.Header.Set("Sign", sign)
  request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
  resp, _ := client.Do(request)
  
  defer resp.Body.Close()
  respBytes, _ := io.ReadAll(resp.Body)
  fmt.Printf("Resp: %s", respBytes)
  }
      `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? CREATE_USER_DEPOSIT_RECOED : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("recordId", "20240227084448114112864297488384");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
        hs.append('0');
    }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? CREATE_USER_DEPOSIT_RECOED : "***"}"
  content = {
    "recordId": "20240227084448114112864297488384"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? CREATE_USER_DEPOSIT_RECOED : "***"}';
  const args = JSON.stringify({'recordId': '20240227084448114112864297488384' });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac('sha256', appSecret)
    .update(signText)
    .digest('hex');
  
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Appid': appId,
      'Sign': sign,
      'Timestamp': timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = '';
  
    res.on('data', (chunk) => {
      respData += chunk;
    });
  
    res.on('end', () => {
      console.log('Response:', respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? CREATE_USER_DEPOSIT_RECOED : "***"}";
  $content   = [
    "recordId" => "",
  ];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const user_deposit_address = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "address": "xxxxxxxxx",
      "memo": ""
    }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${check ? CREATE_USER_DEPOSIT_ADDRESS : "***"}"
    args := []byte(${`{
        "userId": "bsctestaddress001",
        "chain": "BSC"
    }`})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }
      `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${check ? CREATE_USER_DEPOSIT_ADDRESS : "***"}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("userId", "bsctestaddress001");
    map.put("chain", "BSC");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? CREATE_USER_DEPOSIT_ADDRESS : "***"}"
  content = {
      "userId": str(int(time.time() * 1000)),
      "chain": "BSC"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? CREATE_USER_DEPOSIT_ADDRESS : "***"}';
  const args = JSON.stringify({'userId': '1709021102608','chain':'BSC', });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac('sha256', appSecret)
    .update(signText)
    .digest('hex');
  
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Appid': appId,
      'Sign': sign,
      'Timestamp': timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = '';
  
    res.on('data', (chunk) => {
      respData += chunk;
    });
  
    res.on('end', () => {
      console.log('Response:', respData);
    });
  });
  
  req.write(args);
  req.end();
      `,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? CREATE_USER_DEPOSIT_ADDRESS : "***"}";
  $content   = [
    "userId" => "",
    "chain" => "POLYGON",
  ];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const user_deposit_record_list = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "records": [
        {
          "userId": "test01",
          "recordId": "20240801031717170562948710273024",
          "coinId": 1155,
          "chain": "BTC",
          "contract": "BTC",
          "coinSymbol": "BTC",
          "txId": "1a28f67c8f6ececa288676ce3d08c809b4e6e2863aced0e208b8d05ed928eb3c",
          "coinUSDPrice": "63832.79",
          "toAddress": "bc1qqvstvt2cxu5a9ulehu6me58a0q07myztqje34k",
          "toMemo": "",
          'amount': "0.000095",
          "serviceFee": "0.0000078329648446",
          "status": "Success",
          'arrivedAt': 1722482239,
        },
      ],
      "nextId": "",
    },
  }`,
    go: {
      http_ex_code: `package main
  
  import (
  "bytes"
  "crypto/hmac"
  "crypto/sha256"
  "encoding/hex"
  "fmt"
  "io"
  "net/http"
  "time"
  )
  
  func main() {
  
  appId := "*** your appId ***"
  appSecret := "*** your appSecret ***"
  
  // With request params
  path := "${check ? CREATE_USER_DEPOSIT_RECOED_LIST : "***"}"
  args := []byte(${`{
    "userId": "1709021102608"
  }`})
  
  //sign
  timestamp := time.Now().Unix()
  
  signText := fmt.Sprintf("%s%d", appId, timestamp)
  if len(args) != 0 {
    signText = fmt.Sprintf("%s%s", signText, args)
  }
  
  h := hmac.New(sha256.New, []byte(appSecret))
  h.Write([]byte(signText))
  sign := hex.EncodeToString(h.Sum(nil)[:])
  
  fmt.Printf("Sign: %s", sign)
  
  // Making API call
  client := http.Client{}
  request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
  request.Header.Set("Appid", appId)
  request.Header.Set("Sign", sign)
  request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
  resp, _ := client.Do(request)
  
  defer resp.Body.Close()
  respBytes, _ := io.ReadAll(resp.Body)
  fmt.Printf("Resp: %s", respBytes)
  }
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
  String appId = "*** your appId ***";
  String appSecret = "*** your appSecret ***";
  // With request params
  String path = "${check ? CREATE_USER_DEPOSIT_RECOED_LIST : "***"}";
  
  // params
  Map<String, Object> map = new HashMap<>();
  map.put("userId", "1709021102608");
  
  ObjectMapper mapper = new ObjectMapper();
  mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
  String inputString = mapper.writeValueAsString(map);
  
  byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
  // Sign
  long timestamp = new Date().getTime() / 1000L;
  String signText = appId + timestamp;
  if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
  }
  Mac sha256Hmac = Mac.getInstance("HmacSHA256");
  SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
  sha256Hmac.init(secretKey);
  byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
  String sign = byteArrayToHexString(signBytes);
  
  // Making API call
  HttpClient client = HttpClientBuilder.create().build();
  HttpPost request = new HttpPost(path);
  request.setHeader("Appid", appId);
  request.setHeader("Sign", sign);
  request.setHeader("Timestamp", String.valueOf(timestamp));
  request.setEntity(new ByteArrayEntity(requestBody));
  HttpResponse response = client.execute(request);
  BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
  StringBuilder responseText = new StringBuilder();
  String line;
  while ((line = reader.readLine()) != null) {
      responseText.append(line);
  }
  reader.close();
  
  // result
  System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
  StringBuilder hs = new StringBuilder();
  String tempStr;
  for (int index = 0; bytes != null && index < bytes.length; index++) {
    tempStr = Integer.toHexString(bytes[index] & 0XFF);
    if (tempStr.length() == 1) {
       hs.append('0');
    }
    hs.append(tempStr);
  }
  return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${check ? CREATE_USER_DEPOSIT_RECOED_LIST : "***"}"
  content = {
      "userId": "1709021102608",
      # "coinId": 1280,
      # "chain": "POLYGON",
      # "startAt": 1697216461,
      # "endAt": 1708334085,
      # "nextId": "38fe94d7f06594bb9c1832b51601bc"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId ='*** your appId ***';
  const appSecret ='*** your appSecret ***';
  
  const path = '${check ? CREATE_USER_DEPOSIT_RECOED_LIST : "***"}';
  const args = JSON.stringify({'userId': '1709021102608',
    # 'coinId': 1280,
    # 'chain': 'POLYGON',
    # 'startAt': 1697216461,
    # 'endAt': 1708334085,
    # 'nextId': '38fe94d7f06594bb9c1832b51601bc'
      });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
  signText += args;
  }
  
  const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');
  
  const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
  };
  
  const req = https.request(path, options, (res) => {
  let respData = '';
  
  res.on('data', (chunk) => {
    respData += chunk;
  });
  
  res.on('end', () => {
    console.log('Response:', respData);
  });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${check ? CREATE_USER_DEPOSIT_RECOED_LIST : "***"}";
  $content   = [
      "userId" => "6322718677975328",
  ];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
      $sign_text = $sign_text . $body;
  } else {
      $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result); `,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 获取或创建用户地址 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="user-recharge-related-apis" className="title_0">
              {translate("merchant_user_wallet_mode_API.title_3")}
            </Box>
            <Box id="get-or-create-a-user-address" className="title_1">
              {translate("merchant_user_wallet_mode_API.title_3_1")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_1")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_2")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_deposit_address[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取或创建用户地址 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_4")}`,
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_5")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/*Webhook 通知 - User Deposit  */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box id="webhook-notifications-user-deposit" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_6")}
            </Box>
            <Box className="desc code">
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_7"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-recharge-records"} className="link">
                    Just a placeholder
                  </a>
                </Trans>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_7"
                    ) as any,
                  }}
                />
              )}
            </Box>
            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_8")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "type",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_119"),
                },
                {
                  name: "msg",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "msg.recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "msg.userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "msg.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "msg.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "msg.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "UserDeposit",
  "msg": {
    "recordId": "202403130938151...",
    "userId": "6322718677975328",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "amount": "0.1",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-recharge-records" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_12")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_13")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_RECOED} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_deposit_record[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.record.userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.reocrd.contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.record.coinUSDPrice",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_37_"
                  )}`,
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.record.serviceFee",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_21")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_25"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-recharge-history" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_26")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_27")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_RECOED_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={user_deposit_record_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值历史记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].userId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.records[index].contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.records[index].coinUSDPrice",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_37_"
                  )}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.records[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_21")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
